module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/osago-promotion-desktop-dc8ca403451da6172a04afed90cd7b19.png.webp";